// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".print-positions-manager .bx--accordion__content{padding:0 1rem!important;border-top:2px solid #f4f4f4}.print-positions-manager .bx--accordion__heading{width:-moz-fit-content!important;width:fit-content!important}.print-positions-manager .bx--accordion__heading:focus:before{box-sizing:border-box;border:0}.print-positions-manager .bx--accordion__arrow{margin-left:10px!important}.print-positions-manager .bx--accordion__title{font-size:14px}", ""]);
// Exports
module.exports = exports;
